import React from 'react';
import { Card } from '@mantine/core';
import { Switch, Redirect, Route } from 'react-router-dom';
import RegMerchPackages from './RegMerchPackages';

const RegMerchPackageView = () => (
  <Card
    shadow="lg"
    sx={{
      flex: 1,
      border: 'solid 1px lightgrey',
      padding: 15,
      gap: 5,
      alignSelf: 'stretch'
    }}
  >
    <Switch>
      <Route path="/registration/merchandise/packages">
        <RegMerchPackages />
      </Route>
      <Route path="/registration/merchandise/packages/:pkPackage">
        <>package details</>
      </Route>
      <Route path="*">
        <Redirect to="/registration/merchandise/packages" />
      </Route>
    </Switch>
  </Card>
);

export default RegMerchPackageView;
